module.exports = __webpack_public_path__ + "static/media/angle-arrow-down-hover.a3ee995e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-down-hover.svg
// module id = 89
// module chunks = 0